// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-lstdblcx-index-main_right_content-1xahM","table":"components-tjcx-lstdblcx-index-table-2D89D"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/lstdblcx/index.css
// module id = 2310
// module chunks = 0